import React, { useState, useEffect } from "react";
import { getVehicleExp } from "../../../api/endpoints/allReports";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import Example from "./calling.js";
import SideBar from "../../sidebar/sideBar";
import Header from "../../header/header";
import {
  getAllItemsSearch,
  getAllPartySearch,
} from "../../../api/endpoints/search";
import { Select } from "antd";
import { getVehicalByParty } from "../../../api/endpoints/credit.js";

const { Option } = Select;

const VehicleExpReg = () => {
  const { user, access_token } = useSelector(authSelector);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [state, setState] = useState({
    parties: [],
    items: [],
    vehicles: [],
    startingDate: "",
    endingDate: "",
    partyId: "",
    vehicalId: "",
    vehicalName: "",
    partyName: "",
    itemCode: "",
    itemName: "",
  });

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };

  const clearState = () => {
    setItemsQueue([]);
  };

  const clearFields = () => {
    setState({
      parties: state.parties,
      items: state.items,
      partyId: "",
      partyName: "",
      vehicalId: "",
      vehicalName: "",
      itemCode: "",
      itemName: "",
      endingDate: "",
      startingDate: "",
    });
  };

  const editHandler = async (e) => {
    if (!state.startingDate && !state.endingDate)
      return message.error("Please type date !");
    if ((!state.startingDate && !state.endingDate) || !state.vehicalId) {
      return message.error(
        `Please type ${
          !state.startingDate && !state.endingDate
            ? "Date !"
            : !state.vehicalId
            ? "Vehical"
            : ""
        }`
      );
    }
    let data = {
      startingDate: state.startingDate,
      endingDate: state.endingDate,
      partyId: state.partyId,
      vehicalId: state.vehicalId,
      itemCode: state.itemCode,
      siteId: Number(user.siteId),
    };

    console.log(state, "ressaaaaa");
    const results = await getVehicleExp(data, access_token);
    if (results.data.length === 0) {
      message.error("No Record Found in this date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            enteredOn: curr.enteredOn,
            description: curr.description,
            amount: Number(curr.amount),
            siteId: curr.siteId,
          },
        ];
      }, []);
      setItemsQueue(payload);
      console.log(itemsQueue, "FUn");
    } else {
      message.error(results.message);
    }
  };
  const getVehicalByPartyId = async () => {
    const payload = {
      partyId: state.partyId,
    };
    const vehical = await getVehicalByParty(payload, access_token);
    if (vehical.success) {
      setState({
        ...state,
        vehicles: vehical.data,
        // partyName: vehical.data.party.partyName,
      });
    }
  };

  useEffect(() => {
    if (state.partyId) {
      getVehicalByPartyId();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.partyId]);

  const getAllData = async () => {
    const _items = await getAllItemsSearch(access_token);
    const _parties = await getAllPartySearch(access_token);
    setState({
      ...state,
      items: _items,
      parties: _parties,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(state, "payy");

  return (
    <>
      {itemsQueue.length > 0 ? (
        <>
          <div style={{ backgroundColor: "" }}>
            {itemsQueue.length > 0 && (
              <Example
                item={itemsQueue}
                enteredOn={state.startingDate}
                endingDate={state.endingDate}
                itemName={state.vehicalName}
              />
            )}
          </div>
          <div className="pb-3 flex justify-center">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              onClick={clearState}
            >
              Exit
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="flex  bg-black main">
            <SideBar />
            <div className="h-full  flex flex-col content-center  w-full">
              <Header />
              <div className="flex justify-center mt-10">
                <div className="meterTableMain flex flex-col justify-center w-1/2 ml-10 mt-5 mr-10">
                  <div className="bg-blue-500 headingBox flex justify-center">
                    <h1 className="text-white">Vehicle Report</h1>
                  </div>
                  <div className="flex flex-col content-center items-center justify-items-center justify-evenly">
                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-white" htmlFor="startDate">
                          Starting Date:
                        </label>
                        <input
                          type="date"
                          name="startingDate"
                          className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                          onChange={onChangeText}
                        />
                        <label className="text-white ml-5" htmlFor="endDate">
                          Ending Date:
                        </label>
                        <input
                          type="date"
                          name="endingDate"
                          className="text-black inpTxt p-2 h-8 ml-3 mb-3"
                          onChange={onChangeText}
                        />
                      </div>
                    </div>
                    <div className="flex items-center">
                      <Select
                        showSearch
                        className="mt-2 ml-3 h-8 p-1 w-36"
                        placeholder="Party Code"
                        optionFilterProp="children"
                        value={state.partyId || "Party Code"}
                        onChange={(e) => {
                          const lCode = state.parties.find(
                            (el) => el.partyId === e
                          );
                          setState({
                            ...state,
                            partyId: e,
                            partyName: lCode.PartyName,
                          });
                        }}
                      >
                        {state.parties.map((el) => (
                          <Option value={el.partyId} key={el.partyId}>
                            {el.partyId}
                          </Option>
                        ))}
                      </Select>
                      <Select
                        showSearch
                        className="mt-2 ml-3 h-8 p-1 w-60"
                        placeholder="Party Name"
                        optionFilterProp="children"
                        value={state.partyName || "Party Name"}
                        onChange={(e) => {
                          const lCode = state.parties.find(
                            (el) => el.partyId === e
                          );
                          setState({
                            ...state,
                            partyId: e,
                            partyName: lCode.PartyName,
                          });
                        }}
                      >
                        {state.parties.map((el) => (
                          <Option value={el.partyId} key={el.partyId}>
                            {`${el.partyId} - ${el.PartyName}`}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="flex items-center">
                      <Select
                        showSearch
                        className="mt-2 ml-3 h-8 p-1 w-36"
                        placeholder="Vehicle"
                        optionFilterProp="children"
                        value={state.vehicalId || "Vehicle"}
                        onChange={(e) => {
                          const lCode = state.vehicles.find(
                            (el) => el.id === e
                          );
                          setState({
                            ...state,
                            vehicalId: e,
                            vehicalName: lCode.regNumber,
                          });
                        }}
                      >
                        {state.vehicles.map((el) => (
                          <Option value={el.id} key={el.id}>
                            {el.numericNumber}
                          </Option>
                        ))}
                      </Select>
                      <Select
                        showSearch
                        className="mt-2 ml-3 h-8 p-1 w-60"
                        placeholder="Vehicle"
                        optionFilterProp="children"
                        value={state.vehicalId || "Vehicle"}
                        onChange={(e) => {
                          const lCode = state.vehicles.find(
                            (el) => el.id === e
                          );
                          setState({
                            ...state,
                            vehicalId: e,
                            vehicalName: lCode.regNumber,
                          });
                        }}
                      >
                        {state.vehicles.map((el) => (
                          <Option value={el.id} key={el.id}>
                            {`${el.regNumber}`}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div>
                      <Select
                        showSearch
                        placeholder="Select item"
                        className="mt-2 ml-3 h-8 p-1 w-36"
                        optionFilterProp="children"
                        value={state.itemCode || "Item"}
                        onChange={(e) => {
                          const { itemName: productName } = state.items.find(
                            (el) => el.itemCode === e
                          );
                          setState({
                            ...state,
                            itemCode: e,
                            itemName: productName,
                          });
                        }}
                      >
                        {state.items.map((el) => (
                          <Option value={el.itemCode}>{el.itemCode}</Option>
                        ))}
                      </Select>
                      <Select
                        showSearch
                        placeholder="Select Product Name"
                        optionFilterProp="children"
                        className="mt-2 ml-3 h-8 p-1 w-60"
                        value={state.itemName || "Prodct Name"}
                        onChange={(e) => {
                          const { itemName: productName } = state.items.find(
                            (el) => el.itemCode === e
                          );
                          setState({
                            ...state,
                            itemCode: e,
                            itemName: productName,
                          });
                        }}
                      >
                        {state.items.map((el) => (
                          <Option
                            value={el.itemCode}
                          >{`${el.itemCode} - ${el.itemName}`}</Option>
                        ))}
                      </Select>
                    </div>
                    <div className="pb-3 pt-3">
                      <button
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                        onClick={editHandler}
                      >
                        View
                      </button>
                      <button
                        onClick={clearFields}
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-2 ml-3 py-1 px-4 rounded"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default VehicleExpReg;
